<div [class.has-error]="hasError()"
     [class.is-loaded]="isLoaded()"
     class="icon">
    @if (!hasError()) {
        <app-image (imageHasError)="iconImageHasError()" (imageHasLoaded)="iconImageHasLoaded()" [alt]="alt()" [ariaHidden]="true" [height]="height" [lazyLoading]="false" [src]="url()" [width]="width"
                   class="icon-image"
                   imageObjectFit="contain" />
    } @else if (defaultIcon()) {
        <app-icon [svgIcon]="defaultIcon()" class="default-icon-image" />
    }
</div>
